<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form stepform_1">
      <div class="w-layout-grid grid-8 code_validation">
        <div v-if="!OtpConfirmation" data-w-id="df0158ea-1014-a535-54af-948c2261048a" class="notification-bar">
          <p class="body_small pt-0">{{$t('OTP_ERROR')}}</p>
        </div>
        <div id="w-node-_5ec2a138-20c9-6013-c0f0-de0f04da68f8-897bfebf" class="form_field">
          <validation-provider class="" name="OTP" rules="required|digits:6" v-slot="{ errors, classes }">
            <input v-model="data.OTP_CODE" type="text" :class="['text_field_input text-field w-input', OtpConfirmation ? '' : 'error']" autofocus maxlength="256" placeholder="357168" />
            <!-- <div class="form_field"></div>
            </div> -->
            <span :class="classes">{{ errors[0] }}</span>
            <!-- <span :class="classes">To otp einai lathos</span> -->
          </validation-provider>
        </div>
        <div id="w-node-d221c781-86af-7027-d4d7-b6efb77373ff-a23646df" class="form_field">
          <button type="submit" class="submit-button submit-button-2 main_button w-button">{{ $t('CONFIRMATION') }}</button>
          <div class="form_columns split_form_columns w-row">
            <div class="field_column w-col w-col-6"></div>
            <div class="column-12 w-col w-col-6"></div>
          </div>
        </div>
      </div>
    </form>
  </validation-observer>
</template>

<script>
export default {
  mounted() {
    this.$el.querySelector('[autofocus]').focus();
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    OtpConfirmation: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submitForm() {
      this.$emit('otp-confirmation');
    }
  }
};
</script>
